import ApiService from "@/api/baseApi/api-service";
import { Config } from "../../config";
import {
  ICategoryDetailsParams,
  IGetAllCategoryResult,
  IGetCategoryDetailsResult,
} from "./interfaces/api-category-interfaces";

const URLs = {
  categories: "/categories",
};
class ApiCategories extends ApiService {
  constructor(config: Config) {
    super({ ...config });
  }
  getAllCategories = (): Promise<IGetAllCategoryResult> =>
    this.get(URLs.categories, {});
  getCategoryDetails = (
    params: ICategoryDetailsParams
  ): Promise<IGetCategoryDetailsResult> =>
    this.get(URLs.categories + "/" + params.slug, {});
}
export default ApiCategories;
